import { useState } from 'react';
// import ArrowIcon from '../assets/svg/arrow.svg';

const tabs = [
    { id: 'business', label: 'Business Strategy', description: 'Rens has led (digital, business) strategy work for many companies over the years, and delivers the work in a unique way – combining the traditional strategy consultancy toolkit (e.g., insights around market dynamics, competitor landscapes, customer behaviour, pricing power) with carefully orchestrated social moments to ensure top team alignment and the involvement of the right stakeholders from day one. References are available.', content: [''] },
    { id: 'leadership', label: 'Leadership Transformation', description:'Rens has led leadership development efforts for a multitude of clients over the years, and for different audiences (e.g. top teams, top-100, partners, boards, NEDs, high-potentials) and with a wide variety of topics depending on the client needs. Facilitation on these days is typically high-pace, expert-led, and dynamic in nature. Typical collaboration forms are management offsites (1-2 days), management journeys (a year) or single workshops. References are available.', content: ['asdfsa'] },
    { id: 'negotiations', label: 'Complex Negotiations', description: 'Combining his backgrounds in business and psychology, Rens enjoys supporting complex negotiations as ‘lead’ or ‘advisor’, and is also a frequent teacher on the topic. Over the years, Rens has supported negotiations around large contracts, acquisitions, divestitures, funding rounds, management salaries, and G20 treaties. References are available.', content: [''] },
];

const Tabs = () => {
    const [activeTab, setActiveTab] = useState('business');

    return (
        <div className='text-white'>
            <div className='flex space-x-4 lg:space-x-12 border-b border-gray-700'>
                {tabs.map((tab) => (
                    <button
                        key={tab.id}
                        onClick={() => setActiveTab(tab.id)}
                        className={`pb-4 lg:pb-8 text-sm transition-all font-light ${activeTab === tab.id ? 'text-white' : 'text-grey'
                            }`}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>

            <div className='mt-6'>
                {tabs.find((tab) => tab.id === activeTab)?.content.length &&
                    // <div>
                    //     <span className='text-sm lg:text-lg font-normal text-lightGrey'>{tabs.find((tab) => tab.id === activeTab)?.description}</span>
                    //     <div className='grid grid-cols-3 gap-y-4 text-sm lg:text-lg mt-8'>
                    //         {tabs
                    //             .find((tab) => tab.id === activeTab)
                    //             ?.content.map((item, index) => (
                    //                 <div key={index} className='flex items-center space-x-2'>
                    //                     <img src={ArrowIcon} alt='Arrow' className='w-4 h-4' />
                    //                     <span>{item}</span>
                    //                 </div>
                    //             ))}
                    //     </div>
                    // </div>
                    <p className='text-sm mt-8'>
                        {tabs.find((tab) => tab.id === activeTab)?.description}
                    </p>
                }
            </div>
        </div>
    );
};

export default Tabs;
